$.ajaxSetup({
    beforeSend: function(xhr) {
        if (typeof inExternalWebsite !== 'undefined' && inExternalWebsite !== null && inExternalWebsite) {
            xhr.setRequestHeader('X-External-Website', inExternalWebsite);
        }
    }
});

let refreshSharedCookie = function () {
    if (typeof sharedCookieRefreshUrl === 'undefined') {
        console.warn('Unable to refresh shared cookie');
        return;
    }

    $.ajax({
        type: 'GET',
        url: sharedCookieRefreshUrl,
        error: function (jqXHR) {
            console.error('Error refreshing shared cookie: ' + jqXHR.status);
        }
    });
};

let extendWebSession = function () {
    if (typeof extendWebSessionUrl === 'undefined') {
        console.warn('Unable to extend web session');
        return;
    }

    $.ajax({
        type: 'POST',
        url: extendWebSessionUrl,
        error: function (jqXHR) {
            console.error('Error extending web session: ' + jqXHR.status);
        }
    });
};